import { useQuery } from '@tanstack/react-query';
import { SaleAwaitingShipProduct } from '@interfaces/api/responses/my-sale';
import useUser from '@hooks/user/use-user';
import { getSaleAwaitingShipItems } from '@services/my-orders-sales-service';
import { OrdersSalesQueryKeys } from '@enums/react-query-keys';

const useSaleAwaitingShipItems = () => {
  const { isAuthenticated } = useUser();

  return useQuery<SaleAwaitingShipProduct>({
    queryKey: [OrdersSalesQueryKeys.AWAITING_SHIP_PRODUCTS],
    queryFn: () => getSaleAwaitingShipItems(),
    staleTime: Infinity,
    enabled: isAuthenticated,
  });
};

export default useSaleAwaitingShipItems;
